/**
 * Feb 2026 · Sticky mobile bottom navigation.
 *
 * Renders only on <md viewports (`useIsMobile()`). Three tabs:
 *   • Sales      → /sales-dashboard  (default landing per PWA start_url)
 *   • Production → /                 (main Dashboard component)
 *   • Inventory  → /dashboards/inventory
 *
 * Sits fixed at the viewport bottom with a safe-area inset padding so it
 * plays nicely with iPhone home-indicators. Purchase Dashboard is still
 * reachable via direct URL / PWA link — it's just not one of the pinned
 * tabs (per product spec).
 */
import { NavLink } from "react-router-dom";
import { ChartBarIcon, FactoryIcon, WarehouseIcon, ShoppingCartIcon } from "@phosphor-icons/react";
import { useIsMobile } from "@/lib/mobile.jsx";

const TABS = [
  { to: "/sales-dashboard",       label: "Sales",      icon: ChartBarIcon,      testId: "mobile-nav-sales",      exact: true },
  { to: "/",                       label: "Production", icon: FactoryIcon,       testId: "mobile-nav-production", exact: true },
  { to: "/dashboards/purchase",   label: "Purchase",   icon: ShoppingCartIcon,  testId: "mobile-nav-purchase",   exact: true },
  { to: "/dashboards/inventory",  label: "Inventory",  icon: WarehouseIcon,     testId: "mobile-nav-inventory",  exact: true },
];

export default function BottomNav() {
  const isMobile = useIsMobile();
  if (!isMobile) return null;
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[var(--border)] bg-[var(--bg-1)]/95 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="grid grid-cols-4">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.exact}
              data-testid={t.testId}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] uppercase tracking-widest font-semibold ${
                  isActive ? "text-[var(--accent)]" : "text-zinc-400"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={20} weight={isActive ? "fill" : "regular"} />
                  <span>{t.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
